import { isBaidu } from "./useragent";
const Util = {
  //静默唤起后续的操作。
  autoCallAppAuction: (hideCb, showCb) => {
    let hidden, state, visibilityChange;
    if ('hidden' in document) {
      hidden = "hidden";
      visibilityChange = "visibilitychange";
      state = "visibilityState";
    } else if ('webkitHidden' in document) {
      hidden = "webkitHidden";
      visibilityChange = "webkitvisibilitychange";
      state = "webkitVisibilityState";
    } else if ("onfocusin" in document) {
      document.onfocusin = document.onfocusout = onchange;
    } else {
      hidden = "hidden";
    }
    // 添加监听器，在title里显示状态变化
    document.addEventListener(visibilityChange, function () {
      let hide = document[hidden];
      if (hide) {
        hideCb();
      } else {
        showCb();
      }
    }, false);

  },
  getEndChannel: () => {
    let cna = Util.getACookie();
    let _end = 0;
    if (!!cna) {
      //有cna的cookie 就按acookie 来分流
      let int_hash = Util.hashCode(cna) + "";
      _end = (int_hash).substr(int_hash.length - 1, 1);
    } else {
      //如果没有cna 的cookie就看当前时间
      let t = new Date().getTime() + "";
      _end = t.substr(t.length - 1, 1);
    }
    return _end;
  },
  getUrlParms: () => {
    var args = new Object();
    var query = location.search.substring(1);//获取查询串
    var pairs = query.split("&");//在逗号处断开
    for (var i = 0; i < pairs.length; i++) {
      var pos = pairs[i].indexOf('=');//查找name=value
      if (pos == -1) continue;//如果没有找到就跳过
      var argname = pairs[i].substring(0, pos);//提取name
      var value = pairs[i].substring(pos + 1);//提取value
      args[argname] = decodeURIComponent(value);//存为属性
    }
    return args;
  },
  getJsonToParam: function (obj) {
    var str = Object.keys(obj).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
    }).join('&');
    return str;
  },
  getJsonToParamAlipay: function (obj) {
    var str = Object.keys(obj).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
    }).join('?');
    return str;
  },
  getLocationOrigin: () => {
    //兼容ie浏览器
    if (window["context"] == undefined) {
      if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
      }
      window["context"] = location.origin + "/V6.0";
    }
    return window.location.origin;
  },
  getHead: function (doc) {
    return doc.getElementsByTagName('head')[0] || doc.documentElement;
  },
  jsonp: function (options) {
    options = options || {};
    if (!options.url || !options.callback) {
      throw new Error("参数不合法");
    }

    //创建 script 标签并加入到页面中
    var callbackName = ('jsonp_' + Math.random()).replace(".", "");
    var oHead = document.getElementsByTagName('head')[0];
    options.data[options.callback] = callbackName;
    var params = Util.getJsonToParam(options.data);
    var oS = document.createElement('script');
    oHead.appendChild(oS);

    //创建jsonp回调函数
    window[callbackName] = function (json) {
      oHead.removeChild(oS);
      clearTimeout(oS.timer);
      window[callbackName] = null;
      options.success && options.success(json);
    };

    //发送请求
    if (options.url.indexOf("?") != -1) {
      oS.src = options.url + '&' + params;
    } else {
      oS.src = options.url + '?' + params;
    }

    //超时处理
    if (options.time) {
      oS.timer = setTimeout(function () {
        window[callbackName] = null;
        oHead.removeChild(oS);
        options.fail && options.fail({ message: "超时" });
      }, time);
    }
  },
  getScript: (url, jsonpCallback, success) => {
    var scriptNode = window.document.createElement('script');
    var head = Util.getHead(window.document);
    scriptNode.src = url;
    scriptNode.charset = 'GBK';
    scriptNode.async = true;
    head.insertBefore(scriptNode, head.firstChild);
    if (jsonpCallback !== 'getScript') {
      window[jsonpCallback] = success;
    }
    if (scriptNode.readyState) {
      //IE
      scriptNode.onreadystatechange = function () {
        if (/loaded|complete/i.test(scriptNode.readyState)) {
          scriptNode.onreadystatechange = null;
          if (jsonpCallback === 'getScript') {
            if (success) {
              success();
            }
            return;
          }
        }
      }
    } else {
      scriptNode.onload = function () {
        scriptNode.onreadystatechange = null;
        if (jsonpCallback === 'getScript') {
          if (success) {
            success();
          }
          return;
        }
      }
    }
    return scriptNode;
  },
  getACookie: function () {
    var m = document.cookie.match(/(?:^cna|;\s*cna)=(.*?);/);
    var acookie = m ? m[1] : ''
    return acookie;
  },
  hashCode: function (str) {
    let hash = 0;
    if (str.length == 0) return hash;
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
  },
  getCookie: function (name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
      return unescape(arr[2]);
    else
      return null;
  },
  getUrlParam: function (name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    let r = window.location.search.substr(1).match(reg);  //匹配目标参数
    if (r != null) return decodeURIComponent(r[2]); return null; //返回参数值
  },
  isSite: function () {
    return !(!!document.referrer);
  },
  isOriginSEM: function () {
    //是否是sem原站···
    let cosite = Util.getUrlParam('cosite') || '';

    const FROMQ = ["baidujj", "sogoujj", "360jj", "smjj", "qihoojj", "360jj360jj", "baidufeeds_KT", "baidufeeds_kt", "ucfeeds"];
    return FROMQ.includes(cosite) || Util.isFromSEM();
  },
  isFromSEM: function () {
    var spm = Util.getUrlParam("spm") || "";
    return spm.indexOf('a3c0f') != -1
  },
  isReferFromCosite: function () {
    let referer = document.referrer;
    if (!!referer) {
      let cosite = Util.getRequest(referer).cosite || '';
      cosite = cosite.toLowerCase();
      const FROMQ = ["sogoujj", "smjj", "toutiaofeeds"];
      if (isBaidu) {
        return false;
      }

      return FROMQ.includes(cosite)
    }
    return false;
  },
  getRequest: function (url) {
    var theRequest = {};
    if (url.indexOf("?") != -1) {
      var str = url.substring(url.indexOf("?") + 1);
      var strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
      }
    }
    return theRequest;
  },
  isFromSEO: function () {
    var refer = document.referrer;
    if (/m.sm.cn/.test(refer) || /baidu.com/.test(refer) || /so.com/.test(refer) || /sogou.com/.test(refer) || /so.m.sm.cn/.test(refer)) {
      //来源是seo
      return true;
    } else {
      return false;
    }
  },
  isFromCPS: function () {
    return !!Util.getCookie("ta_info")
  },
  myDOMReady: (fn) => {
    //如果当前dom已经ready直接执行
    if (document.readyState === "complete" || document.readyState === "interactive") {
      fn();
      return;
    }
    //判断如果支持addEc=ventListener（非IE--IE支持的是attachEvent）则绑定DOMContentLoaded事件
    if (document.addEventListener) {
      document.addEventListener("DOMContentLoaded", fn, false);
    } else {
      IEContenLoaded(fn);
    }
    //IE下模拟DOMContentLoaded
    function IEContenLoaded(fn) {
      var done = false;
      //只执行一次用户的回调函数init
      var init = function () {
        if (!done) {
          done = true;
          fn();
        }
      }
        (function () {
          try {
            //DOM树未创建完之前调用doScroll会抛出错误
            window.document.documentElement.doScroll("left");
          } catch (error) {
            //延迟再执行，arguments.callee调用自己
            setTimeout(argument.callee, 1);
            return;
          }
          //没有错误表示DOM树创建完毕，执行用户回调
          init();
        })();
      //监听document的加载状态
      window.document.onreadystatechange = function () {
        //如果用户是在DOMReady之后调用的函数立即执行用户回调
        if (window.document.readyState == 'complete') {
          window.document.onreadystatechange = null;
          init();
        }
      }
    }
  }
}

export default Util;



// WEBPACK FOOTER //
// ./src/util/index.js